import { createSelector } from '@ngrx/store';
import { denormalize } from 'normalizr';
import {
  ByKey,
  createListStateIdsSelector,
  createListStateParamsSelector,
  createStateErrorsSelector,
  createStateLoadingSelector,
  createStateSuccessSelector,
  IdType,
  ListState
} from '@industi/ngx-common';
import { EntityTypes } from '../../entity/entity-types';
import { createEntitiesSelector } from '../../entity/entities.reducer';
import { createSymfonyTotalCountSelector } from '../../symfony/list/selectors/list.selectors';
import { Entities } from '../../entity/entities';
import { EntityState } from '../../entity/entity.reducer';
import { getModelListState } from '../model.reducer';
import { Model } from '../models/model';

const createState = (id: IdType) => createSelector(
  getModelListState,
  (state: ByKey<ListState>) => state && state[id]
);

const createStateByContext = (id: IdType) => createListStateIdsSelector(createState(id));

export const createModelListData = (id: IdType) => createSelector(
  createStateByContext(id),
  createEntitiesSelector([
    EntityTypes.model
  ]),
  (
    ids: IdType[],
    entities: EntityState
  ) => denormalize(ids, [Entities[EntityTypes.model]], entities) as Model[]
);

export const createModelListLoading = (id: IdType) => createStateLoadingSelector(
  createState(id));

export const createModelListSuccess = (id: IdType) => createStateSuccessSelector(
  createState(id));

export const createModelListErrors = (id: IdType) => createStateErrorsSelector(
  createState(id));

export const createModelListTotalCount = (id: IdType) => createSymfonyTotalCountSelector(
  createState(id));

export const createModelListParams = (id: IdType) => createListStateParamsSelector(
  createState(id));
